"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalStyles = exports.SuggestionLinkText = exports.SuggestionLinkWrapper = exports.SectionContent = exports.SectionTitle = exports.SuggestionSectionContainer = void 0;
var merch_components_1 = require("@carvana/merch-components");
var SuggestionLink_1 = __importDefault(require("./SuggestionLink"));
exports.SuggestionSectionContainer = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-col gap-16'
});
exports.SectionTitle = (0, merch_components_1.createComponent)('span', {
    className: 'text-base font-semibold leading-5 text-blue-6'
});
exports.SectionContent = (0, merch_components_1.createComponent)('div', {
    className: 'flex flex-wrap gap-8'
});
exports.SuggestionLinkWrapper = (0, merch_components_1.createComponent)(SuggestionLink_1.default, {
    className: 'flex items-center gap-8 rounded border border-grey-2 bg-white px-12 py-[7px] transition-all hover:border-grey-3 hover:bg-grey-1'
});
exports.SuggestionLinkText = (0, merch_components_1.createComponent)('span', {
    className: 'select-none whitespace-nowrap text-sm text-blue-6'
});
exports.modalStyles = 'no-scrollbar overflow-x-auto px-16';
//# sourceMappingURL=DefaultSuggestions.styles.js.map